import { atomFamily } from 'recoil';
import { GridRow } from '../../../api/generated/data-contracts';

type Indexify<T> = T & { [key: string]: any };

export const rowMetadataAtoms = atomFamily<Record<string, any> | null, Indexify<GridRow>>({
    key: 'allocation-row',
    default: ({ metadata }: GridRow) => metadata,
});
